import React, { Component } from 'react';
import './BulkDropZone.css';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import _ from 'lodash';
import FormWrapper from "../formWrapper/FormWrapper.container";
import { NavLink, Alert } from 'reactstrap';
import { Link } from "react-router-dom";
import Papa from 'papaparse';
import { CryptoUtils } from '../../../utils/cryptoUtils';
import { TITLES_LANGS } from '../../../constants/constants';
import convert from 'xml-js';
import SigningProgressModal from './signingProgressModal/SigningProgressModal.container';
import { Utils } from '../../../utils/utils';

const MAX_FILE_SIZE = '20 MB';
const CSV_FILE = "CSV_FILE";
const XML_FILE = "XML_FILE";

class BulkDropZone extends Component {
    constructor(props) {
        super(props);

        this.count = 0;

        this.state = {
            isEnter: false,
            file: null,
            error: false,
            startParsing: false,
            startSigning: false,
            amount: null,
            signed: null
        };
    };

    render() {
        return (
            <div className='bulk-drop-zone-container'>
                <div className="bulk-drop-zone-info">
                    <span>{_.get(this.props.translation, 'bulk_upload.max_file_size_message')}: {MAX_FILE_SIZE}</span>

                    <NavLink tag={Link} to="/bulk-accreditations-upload/format-details">
                        {_.get(this.props.translation, 'bulk_upload.file_format_details_label')}
                    </NavLink>
                </div>
                <FormWrapper>
                    <Dropzone
                        className='bulk-drop-zone'
                        activeClassName='bulk-drop-zone-active'
                        onDrop={this.onDrop}
                        multiple={false}
                        onDragEnter={this.onDragEnter}
                        onDragLeave={this.onDragLeave}
                        onClick={this.cleanState}
                    >
                        <div
                            className={'bulk-drop-zone-content-container ' + (this.state.isEnter ? 'bulk-drop-zone-content-active' : '')}>
                            <h6>{_.get(this.props.translation, 'bulk_upload.drag_and_drop_label')}</h6>
                            <h6>{_.get(this.props.translation, 'bulk_upload.or_label')}</h6>
                            <h6>{Utils.getTagsFromStringWithStyles(_.get(this.props.translation, 'bulk_upload.browse_label'))}</h6>
                        </div>
                    </Dropzone>
                    <h6 className="bulk-result-label">
                        {this.state.error ? _.get(this.props.translation, 'bulk_upload.error_label') : ""}
                        {!_.isNil(this.state.file) ? (_.get(this.props.translation, 'bulk_upload.uploaded_file_label') + ": " + this.state.file.name) : ""}
                    </h6>
                    <Alert className="text-center" color="warning" hidden={!this.state.startParsing}>
                        {_.get(this.props.translation, 'bulk_jobs_list.file_reading_process_label')}
                        {_.get(this.props.translation, 'bulk_jobs_list.dont_close_tab_label')}
                    </Alert>
                </FormWrapper>
                <SigningProgressModal
                    startSigning={this.state.startSigning}
                    amount={this.state.amount}
                    signed={this.state.signed}
                />
            </div>
        );
    }

    formatIsCorrect = (file) => {
        return file.name.endsWith('.csv') || file.name.endsWith('.xml');
    };

    getFileFormat = (file) => {
        if (file.name.endsWith('.xml')) {
            return XML_FILE;
        }

        if (file.name.endsWith('.csv')) {
            return CSV_FILE
        }
    }

    onDragEnter = () => {
        this.setState({ isEnter: true });
        this.cleanState();
    };

    onDragLeave = () => {
        this.setState({ isEnter: false });
    };

    onDrop = (filesArray) => {
        this.setState({ isEnter: false });

        if (filesArray.length !== 1) {
            this.setState({ error: true });
            return;
        }

        let file = filesArray[0];
        if (this.formatIsCorrect(file)) {
            this.setState({ file: file });
            if (!this.props.isSigningRequired) {
                let data = new FormData();
                data.append('file', file);
                this.props.onUploadBulkAccreditationsAsFile(data);
            } else {
                this.onStartParsing();
                this.parseFile(file);
            }
        } else {
            this.setState({ error: true });
        }
    };

    onStartParsing = () => {
        this.props.onSetLoading();
        this.setState({
            startParsing: true
        });
    };

    onStartSigning = (amount) => {
        this.setState({
            startParsing: false,
            startSigning: true,
            signed: 0,
            amount: amount
        });
    };

    onFinishSigning = () => {
        this.setState({
            startSigning: false,
            signed: null,
            amount: null
        });
        this.count = 0;
    };

    onSignAccreditation = () => {
        // TODO: add correct progress showing
        if (this.state.amount < 100) {
            this.setState({ signed: this.state.signed + 1 });
        } else {
            this.count++;
            if (this.count === 50 || this.count === this.state.amount - this.state.signed) {
                this.setState({ signed: this.state.signed + this.count });
                this.count = 0;
            }
        }
    };

    parseFile = (file) => {
        let fileFormat = this.getFileFormat(file);

        switch (fileFormat) {
            case CSV_FILE:

                Papa.parse(file, {
                    header: true,
                    skipEmptyLines: true,
                    complete: this.signCSVAccreditations
                });

                break;

            case XML_FILE:
                this.signXMLAccreditations(file);

                break;

            default:
                break;
        }
    };

    signCSVAccreditations = (result) => {
        this.onStartSigning(result.data ? result.data.length : null);

        let data = _.map(result.data, (elem) => {
            let titles = {};
            TITLES_LANGS.forEach(lang => {
                if (elem[lang]) titles[lang] = elem[lang];
            });
            return {
                email: elem.email,
                accreditationData: {
                    titles: titles,
                    issuedAt: elem.issuedAt,
                    level: elem.level
                },
                verifiedIdentity: {
                    firstName: elem.firstName,
                    lastName: elem.lastName,
                    countryCode: elem.countryCode,
                    nationalId: elem.nationalId
                }
            };
        })

        let promises = _.map(data, (elem) => {
            return CryptoUtils.signAccreditation(this.props.signingKey, elem).then((signedElem) => {
                this.onSignAccreditation();
                return signedElem;
            })
        })

        Promise.all(promises).then((results) => {
            this.onFinishSigning();
            let data = {
                fileName: this.state.file.name,
                requests: results
            }
            this.props.onUploadBulkAccreditationsAsJSON(data);
        })
    };

    signXMLAccreditations = (file) => {
        let reader = new FileReader();
        reader.readAsText(file);

        reader.onloadend = () => {
            let result = convert.xml2js(reader.result, {
                compact: true, spaces: 4, elementNameFn: function (name) {
                    return name.slice(name.search(':') + 1);
                }
            });

            this.onStartSigning(_.get(result, 'accreditations.accreditation') ? _.get(result, 'accreditations.accreditation').length : null);

            let data = _.map(_.get(result, 'accreditations.accreditation'), (elem) => {
                let titles = {};
                _.map(_.get(elem, 'titles.title'), (title) => {
                    titles[_.get(title, '_attributes.language')] = _.get(title, '_text');
                });

                return {
                    email: _.get(elem, 'email._text'),
                    accreditationData: {
                        titles: titles,
                        issuedAt: _.get(elem, 'issuedAt._text'),
                        level: _.get(elem, 'level._text')
                    },
                    verifiedIdentity: {
                        firstName: _.get(elem, 'firstName._text'),
                        lastName: _.get(elem, 'lastName._text'),
                        countryCode: _.get(elem, 'countryCode._text'),
                        nationalId: _.get(elem, 'nationalId._text')
                    }
                };
            })

            let promises = _.map(data, (elem) => {
                return CryptoUtils.signAccreditation(this.props.signingKey, elem).then((signedElem) => {
                    this.onSignAccreditation();
                    return signedElem;
                })
            })

            Promise.all(promises).then((results) => {
                this.onFinishSigning();
                let data = {
                    fileName: this.state.file.name,
                    requests: results
                }
                this.props.onUploadBulkAccreditationsAsJSON(data);
            })
        }
    }

    cleanState = () => {
        this.setState({
            file: null,
            error: false
        });
    };
}

BulkDropZone.propTypes = {
    translation: PropTypes.object.isRequired,
    signingKey: PropTypes.object,
    isSigningRequired: PropTypes.bool,
    onUploadBulkAccreditationsAsFile: PropTypes.func,
    onUploadBulkAccreditationsAsJSON: PropTypes.func,
    onSetLoading: PropTypes.func
};

export default BulkDropZone;



// WEBPACK FOOTER //
// ./src/components/commonComponents/bulkDropZone/BulkDropZone.js